function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import BaseForm from 'react-formal';
import FormCheck from './FormCheck';
import FormControl from './FormControl';
import FormControlFile from './FormControlFile';
/**
 * `FormInput` consolidates a few distinct presentational Form control components and integrates them
 * with `react-formal`. While not technically coupled to `react-formal`, `FormInput` assumes it will be used
 * as a `type` in `Form.Field`, and adds some convenient mapping from RF form state to shared visual styles.
 * e.g. Field validity is mapped to the `invalid` FormControl prop, in order to show a validation error bar.
 *
 * `FormInput` will correctly render all native HTML input types, choosing the appropriate presentational component
 * for the input type.
 *
 * **NOTE:** This component should generally not be used directly, instead prefer the base presentational component
 * (FormControl, Checkbox, etc) that best suits your custom components needs and wrapper that
 *
 * @alias FormField
 */

const BflyFormField = React.forwardRef(({
  children,
  as,
  ...props
}, ref) => React.createElement(BaseForm.Field, _extends({
  ref: ref
}, props), innerProps => {
  if (typeof children === 'function') return children(innerProps);
  const { ...fieldProps
  } = innerProps;
  const {
    type
  } = fieldProps;
  let Input = as;

  if (!Input) {
    if (/checkbox|radio/.test(type)) {
      Input = FormCheck;
      fieldProps.checked = fieldProps.value;
      fieldProps.value = props.value;
    } else if (type === 'file') {
      Input = FormControlFile;
    } else {
      Input = FormControl;
    }
  }

  return React.createElement(Input, fieldProps, children);
}));
BflyFormField.displayName = 'BflyFormField';
export default BflyFormField;